import React from 'react';
import { Button } from 'antd';
import timeFormat from '../../utils/timeFormat';
import declinationOfNumerals from '../../utils/declinationOfNumerals';
import type { TestModel } from './types';

interface TestStartInfoProps {
  test: TestModel;
  attemptsLimit?: number;
  onStart: () => void;
}

const TestStartInfo: React.FC<TestStartInfoProps> = ({ test, attemptsLimit = 3, onStart }) => {
  const questionsAmount = Number(test?.questionsAmount ?? 0);
  const attemptsCount = Number(test?.attemptsCount ?? 0);
  const nextAttempt = test?.nextAttempt;
  const testTimeSeconds = Number(test?.testTime ?? 0);
  const attemptsLeft = Math.max(attemptsLimit - attemptsCount, 0);
  const canStart = attemptsLeft > 0;
  const minutes = Math.ceil(Math.max(testTimeSeconds, 0) / 60);
  const timeText = `${timeFormat(testTimeSeconds)} ${declinationOfNumerals(minutes, ['минута', 'минуты', 'минут'])}`;

  return (
    <div style={{ marginTop: 30, fontSize: 18, textAlign: 'center' }}>
      Кол-во вопросов в тесте: {questionsAmount}
      <br />
      <br />
      На прохождение теста у вас есть {timeText}
      <br />
      <br />
      {attemptsLeft > 0 ? (
        <div>
          Осталось {attemptsLeft} {declinationOfNumerals(attemptsLeft, ['попытка', 'попытки', 'попыток'])}
        </div>
      ) : (
        <div>У вас не осталось попыток</div>
      )}
      <br />
      {canStart ? (
        <Button type="primary" onClick={onStart}>
          Начать тест
        </Button>
      ) : (
        nextAttempt ? <div>Вы можете попробовать снова после: <b>{nextAttempt}</b></div> : <div>Лимит попыток исчерпан</div>
      )}
    </div>
  );
};

export default TestStartInfo;
